import script from "./TypeBMuseumPremialita.vue?vue&type=script&setup=true&lang=ts"
export * from "./TypeBMuseumPremialita.vue?vue&type=script&setup=true&lang=ts"

import "./TypeBMuseumPremialita.vue?vue&type=style&index=0&id=1745bd13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1745bd13"]])

export default __exports__